import React from "react";
import { Loader2, Navigation2, LogOut, MapPin, Wifi } from "lucide-react";
import { toast } from "sonner";
import { updateUnit } from "../../lib/api";

const OPTIONS = [
  { s: "available", label: "Available", c: "#22E0A1" },
  { s: "enroute", label: "En Route", c: "#38BDF8" },
  { s: "deployed", label: "On Scene", c: "#FFC726" },
  { s: "out_of_service", label: "Off Duty", c: "#8194B2" },
];

const FieldStatus = ({ officer, unit, onChanged, onLogout }) => {
  const [busy, setBusy] = React.useState(false);
  const status = unit?.status || "available";

  const setStatus = async (s) => {
    setBusy(true);
    try { await updateUnit(officer.id, { status: s }); onChanged && onChanged(); toast.success(`Status: ${OPTIONS.find((o) => o.s === s)?.label}`); }
    catch { toast.error("Update failed"); } finally { setBusy(false); }
  };

  const pushGps = () => {
    if (!navigator.geolocation) return toast.error("GPS not available");
    navigator.geolocation.getCurrentPosition(
      async (p) => { try { await updateUnit(officer.id, { lat: p.coords.latitude, lng: p.coords.longitude }); onChanged && onChanged(); toast.success("Location sent to command"); } catch { toast.error("Failed"); } },
      () => toast.error("Enable GPS"), { enableHighAccuracy: true, timeout: 8000 });
  };

  const cur = OPTIONS.find((o) => o.s === status) || OPTIONS[0];

  return (
    <div className="go-scroll min-h-full overflow-y-auto px-5 pb-28 pt-[max(env(safe-area-inset-top),16px)]">
      <header className="go-fade-up mb-5"><h1 className="font-head text-2xl font-extrabold text-white">My Status</h1>
        <p className="mt-1 text-sm text-[#8194B2]">{officer?.callsign} · {officer?.service}</p></header>

      <div className="go-card rounded-3xl p-6 text-center" style={{ borderTop: `4px solid ${cur.c}` }}>
        <div className="text-xs font-bold uppercase tracking-widest text-[#67799A]">Current status</div>
        <div className="font-head mt-1 text-3xl font-extrabold" style={{ color: cur.c }} data-testid="my-status">{cur.label}</div>
        {unit?.assignment && <div className="mt-2 text-sm text-[#A9B8D2]">Assignment: {unit.assignment}</div>}
      </div>

      <h3 className="font-head mb-3 mt-6 text-sm font-bold uppercase tracking-wide text-[#67799A]">Set status</h3>
      <div className="go-grid2">
        {OPTIONS.map((o) => (
          <button key={o.s} onClick={() => setStatus(o.s)} disabled={busy} className={`rounded-2xl border-2 py-4 font-head text-sm font-bold transition-all active:scale-95 ${status === o.s ? "" : "go-card border-transparent text-white"}`} style={status === o.s ? { background: `${o.c}22`, borderColor: o.c, color: o.c } : {}} data-testid={`set-status-${o.s}`}>{o.label}</button>
        ))}
      </div>

      <button onClick={pushGps} className="go-card mt-5 flex w-full items-center justify-center gap-2 rounded-full py-3.5 text-sm font-bold text-[#5B9BFF] active:scale-[0.98]" data-testid="push-gps">
        <MapPin size={18} strokeWidth={2.4} /> Send my live location
      </button>

      <div className="mt-5 flex items-center justify-center gap-2 text-xs text-[#4F6180]"><Wifi size={13} /> Location shared with National Command in real time</div>

      <button onClick={onLogout} className="mt-8 flex w-full items-center justify-center gap-2 rounded-full border border-white/10 py-3.5 text-sm font-bold text-[#FF7089] active:scale-[0.98]" data-testid="field-logout">
        <LogOut size={17} strokeWidth={2.4} /> Go off duty
      </button>
    </div>
  );
};

export default FieldStatus;
